export class ClientFiles {
    constructor() {
        this.Init();
    }

    current: number
    files: HTMLCollectionOf<Element>
    file: string
    empty_notice: HTMLElement

    directory: object[]
    directoryElement: any

    Init() {
        this.current = 0;
        this.files = document.getElementsByClassName('client-zone');
        this.files = this.files[0].getElementsByClassName("folder");
        this.directoryElement = document.getElementsByClassName("history")[0].getElementsByClassName('directory')[0];
        this.directory = [];

        this.empty_notice = document.getElementById('no_resources_notice');

        this.loadFiles();
        this.directory.push({ 'ID': 0, 'name': 'Home' });
        this.addDirectory('Home', 0);

        let MainFunc = this;
        jQuery('.folder:not(.file)').on('click', function () {
            MainFunc.current = parseInt(this.getAttribute('data-id'));
            MainFunc.directory.push({ 'ID': this.getAttribute('data-id'), 'name': this.getAttribute('data-name') })
            MainFunc.addDirectory(this.getAttribute('data-name'), this.getAttribute('data-id'))
            MainFunc.loadFiles();

            if (MainFunc.current == 0) {
                jQuery(".back-button").css("display", "none");
            } else {
                jQuery(".back-button").css("display", "flex");
            }

        });
        jQuery('.client-zone .folder.file').on('click', function () {
            MainFunc.file = this.getAttribute('data-file');
            MainFunc.openFile();
        });
        // jQuery('.return .icon').on('click', () => { this.return(); })


        jQuery(".back-button").on("click", function (e) {
            console.log("back")
            let num = jQuery(".directory a").length - 2;
            console.log(num);
            jQuery(".directory a")[num].click();
        });
    }

    loadFiles() {
        let empty = true;
        for (let i = 0; i < this.files.length; i++) {
            console.log("Current", this.current);
            console.log((this.files[i].getAttribute('data-parent').split(',')).indexOf(this.current as any));
            if (this.files[i].getAttribute('data-parent').split(',').indexOf((this.current as any).toString()) > -1) {
                this.files[i].classList.add("display");
                empty = false;
            } else {
                this.files[i].classList.remove("display");
            }
        }
        if (empty) {
            this.empty_notice.classList.add('display');
        } else {
            this.empty_notice.classList.remove('display');
        }
    }

    openFile() {
        window.open(this.file, '_blank');
    }

    addDirectory(name, id) {
        let page = document.createElement('a');
        let backslash = document.createTextNode('/');
        let MainFunc = this;
        page.innerHTML = name;
        page.setAttribute('data-id', id);
        page.onclick = function () {
            MainFunc.changeDirectory(this);
        }
        this.directoryElement.appendChild(page);
        this.directoryElement.appendChild(backslash);
        jQuery(this.empty_notice).find('.folder_name').html(name);
    }

    changeDirectory(page) {
        this.current = page.getAttribute('data-id');
        this.directoryElement.innerHTML = "";
        for (let i = 0; i < this.directory.length; i++) {
            this.addDirectory(this.directory[i]['name'], this.directory[i]['ID'])
            if (this.directory[i]['ID'] == this.current) {
                this.directory.length = i + 1;
                break;
            }
        }

        if (this.current == 0) {
            jQuery(".back-button").css("display", "none");
        } else {
            jQuery(".back-button").css("display", "flex");
        }

        this.loadFiles();
    }

    // return() {

    // }
}